import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetWorkflowRuleFieldOutputOptionsQueryVariables = GraphQLTypes.Exact<{ [key: string]: never }>;

export type GetWorkflowRuleFieldOutputOptionsQueryResult = { __typename?: 'Query' } & {
  workflowRuleFieldOutputOptions: Array<
    { __typename?: 'WorkflowRuleFieldType' } & Pick<GraphQLTypes.WorkflowRuleFieldType, 'component' | 'label' | 'name'>
  >;
};

export const GetWorkflowRuleFieldOutputOptionsDocument = gql`
  query getWorkflowRuleFieldOutputOptions {
    workflowRuleFieldOutputOptions {
      component
      label
      name
    }
  }
`;
